<template>
  <div>
    <v-card class="mx-2 mx-sm-3 my-md-4 sectionCard" flat bordered>
      <div
        class="cardTitle text-sm-center d-flex flex-row align-center"
        :class="{ pointer: isMobile }"
        @click="
          if (isMobile) {
            localExpand = !localExpand;
          }
        "
      >
        <div :class="isMobile ? 'sectionImg_sm' : 'sectionImg'">
          <v-img
            v-if="caseObj.image"
            :src="imgPath + caseObj.image"
            contain
            :class="isMobile ? 'sectionImg_sm' : 'sectionImg'"
          /><!--  style="border: 1px solid #a2d7ff" -->
        </div>
        <div
          class="text-sm-h6 darkerCardText py-2 pl-4"
          :class="{ size1em: isMobile }"
        >
          {{ caseObj.title }}
        </div>
        <v-spacer></v-spacer>
        <!-- <v-icon v-if="isMobile"
          >mdi-{{ localExpand ? "chevron-up" : "chevron-down" }}</v-icon
        > -->

        <!-- <v-btn icon v-if="isMobile" @click="localExpand = !localExpand"
          > -->
        <v-icon v-if="isMobile"
          >mdi-{{ localExpand ? "chevron-up" : "chevron-down" }}</v-icon
        >
        <!-- </v-btn
        > -->
        <!-- <div v-if="show[`${typeKey}_${sectionIndex}`]">
      
      </div> -->
      </div>

      <v-expand-transition>
        <v-card-text class="darkerCardText pa-2" v-if="localExpand">
          <table>
            <tr>
              <th>Case</th>
              <td>
                <vue-markdown>{{ caseObj.details }}</vue-markdown>
              </td>
            </tr>
            <tr>
              <th>Diagnosis</th>
              <td>
                <vue-markdown>{{ caseObj.dx }}</vue-markdown>
              </td>
            </tr>
            <tr>
              <th>Exam Code</th>
              <td>
                <vue-markdown>{{ caseObj.exam_code }}</vue-markdown>
              </td>
            </tr>
            <tr>
              <th>Procedure Code</th>
              <td>
                <vue-markdown>{{ caseObj.procedure_code }}</vue-markdown>
              </td>
            </tr>
            <tr v-if="caseObj.follow_up">
              <th>Follow-Up</th>
              <td>
                <vue-markdown>{{ caseObj.follow_up }}</vue-markdown>
              </td>
            </tr>
            <tr>
              <th>Discussion</th>
              <td>
                <vue-markdown>{{ caseObj.explanation }}</vue-markdown>
              </td>
            </tr>
            <tr v-if="caseObj.files">
              <th>More Info</th>
              <td>
                <!-- {{ caseObj.files }} -->
                <pdf-viewer
                  v-for="file in caseObj.files"
                  :key="file.file"
                  :url="pdfPath + file.file"
                  backBtnLabel="Back to Coding Examples"
                  ><div class="linkLike">
                    <v-icon color="primary" class="mr-2"
                      >mdi-file-pdf-box</v-icon
                    >{{ file.name }}
                  </div>
                </pdf-viewer>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import VueMarkdown from "@adapttive/vue-markdown";

// import Name from "../dir/file";

export default {
  name: "CodingExampleTable",
  components: {
    VueMarkdown,
    PdfViewer: () => import("@/components/universalStuff/PdfViewer.vue"),
  },
  props: { caseObj: null, expandAll: { type: Boolean, default: true } },
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images/billingCodes/",
      pdfPath: "https://www.eyedock.com/images/billingCodes/medicarePDFs/",
      localExpand: true,
    };
  },
  methods: {},
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
  },
  watch: {
    expandAll(val) {
      this.localExpand = val;
    },
  },
};
</script>

<style scoped>
.typeDiv {
  background-color: #c3e4ff;
  border: 1px solid #bcbcbc;
  border-radius: 5px;
}
.sectionCard {
  border: 1px solid #bcbcbc !important;
}
.cardWidth {
  /* max-width: 50%;
      min-width: 350px; */
  width: 100%;
}
.cardTitle {
  background-color: #c3e4ff;
  border-bottom: 1px solid #bcbcbc !important;
}
.width98 {
  width: 98%;
}
table {
  border-collapse: collapse;
  background-color: #fff;
}
th,
td {
  vertical-align: top;
  padding: 4px 8px 0;
  border: 1px solid #e0e0e0;
}

tr:nth-child(odd) {
  background-color: #f3faff;
}
.sectionImg {
  width: 150px;
  max-height: 50px;
  /* border: 1px solid #a2d7ff; */
}
.sectionImg_sm {
  width: 90px;
  max-height: 30px;
  /* border: 1px solid #a2d7ff; */
}
</style>
